import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { BaseChartProps } from '../types/chartProps';
import { applyBarChartOptions } from '../utils/barChartUtils';
import { applyRedrawForBaseChart } from '../utils/baseChartUtils';
import { mergeWithDefaults } from '../utils/chartDefaults';

export const HorizontalGroupedBarChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, BaseChartProps>((props, ref) => {
    const redraw = { skip: false };
    const options: Highcharts.Options = applyBarChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'bar',
          events: {
            redraw: applyRedrawForBaseChart(redraw)
          }
        }
      }),
      { ...props, kind: 'bar' }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
